<template>
    <transition name="cal__modal">
        <div class="cal__modal_mask">
          <div class="cal__modal_wrapper">
            <div class="cal__modal_container" :class="{ 'cal__modal_container--email': type === 'email', 'cal__modal_container--merci': type === 'merci' }">

              <div class="cal__modal_close" v-on:click="closeModal">
                <span class="cal__modal_close_cross"></span>
              </div>

              <div class="cal__modal_header">
                <div v-if="type === 'saisie'" class="cal__modal_header--saisie">Merci de corriger votre saisie</div>
                <div v-if="type === 'max'" class="cal__modal_header--max">Ouch ! Votre budget dépasse 100 000 €</div>
                <div v-if="type === 'job'" class="cal__modal_header--job">
                    <span class="cal__modal_job_i">i</span>
                    <br><span class="cal__modal_job_title">{{ job.titre }}</span>
                    <br><span class="cal__modal_job_tjm">TJM : {{ formatNumber(job.tjm_ht) }} / jour</span>
                </div>
              </div>

              <div class="cal__modal_body">
                <div v-if="type === 'saisie'" class="cal__modal_body--saisie">
                  Merci de saisir un nombre entre 1 et 99 avec
                  <br>éventuellement un chiffre après la virgule.
                  <br>Point ou virgule comme séparateur décimal
                </div>
                <div v-if="type === 'max'" class="cal__modal_body--max">
                    Il faut vite qu'on se parle <span class="cal__modal_emoji">😉</span><br>au 01.84.17.70.20
                    <br><br>Ou télécharger l'Excel, il n'y a pas de limites !
                </div>
                <div v-if="type === 'job'" class="cal__modal_body--job">
                    <div><strong>Profil :</strong> {{ job.experience }}</div>
                    <span class="cal__modal_body_separator"></span>
                    <div v-html="formatProfilIntervention(job.profil)"></div>
                    <span class="cal__modal_body_separator"></span>
                    <div v-html="formatProfilInteraction(job.profil)"></div>
                </div>
                <div v-if="type === 'email'" class="cal__modal_body--email">
                    <div class="cal__modal_body_icone_img">
                        <img src="../assets/img/excel-content-icone-mobile.jpg" >
                    </div>
                    <div class="cal__modal_body_title cal__font_bree">
                        Recevez le fichier source
                        <br>Excel (avec TJM
                        <br>modifiables)
                        <br>de cette simulation.
                        <br><br>
                        Idéal pour vos 
                        <br>présentations !
                    </div>
                    <div class="cal__modal_body_email">
                        <form v-on:submit="checkForm">
                            <input 
                                type="text"
                                class="cal__excel_input"
                                :class="{ 'cal__excel_input--error': this.error === true}"
                                placeholder="Votre email*"
                                v-bind:email="email"
                                v-on:input="updateEmail"
                                v-bind:value="email" >
                            <input class="cal__excel_submit" type="submit" value="ok" >
                          </form>
                    </div>
                    <div class="cal__modal_body_mentions">
                        *Inscription conforme
                        <br><a href="https://www.eficiens.com/privacy/" target="_blank">RGPD Eficiens</a>
                        <br>Aucune exploitation de votre email.
                    </div>
                </div>
                <div v-if="type === 'merci'" class="cal__modal_body--merci">
                    <div class="cal__modal_body_icone_img">
                        <img src="../assets/img/bonhomme-2.svg" >
                    </div>
                    <div class="cal__modal_body_title cal__font_bree">
                        Merci. Vous allez recevoir
                        <br>prochainement les fichiers
                        <br>demandés.
                        <br><br>
                        Si vous souhaitez nous 
                        <br>contacter :
                        <br><span class="cal__underline">contact@eficiens.com</span>
                    </div>
                    <div class="cal__modal_body_icone_footer">
                         <img src="../assets/img/soon-mobile.jpg" >
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
    </transition>
</template>

<script>

import { formatNumber, formatProfilIntervention, formatProfilInteraction } from "../utils/index";

export default {
    name: 'Modal',
    props: {
      type: String,
      job: Object
    },
    data: function(){
        return {
          email: '',
          error: false,
          emailRegex: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
      },
    methods: {
      closeModal() {
        this.$store.commit('CLOSE_MODAL')
      },
      formatNumber: function(nb) {
        return formatNumber(nb)
      },
      formatProfilIntervention: function(profil) {
        return formatProfilIntervention(profil)
      },
      formatProfilInteraction: function(profil) {
        return formatProfilInteraction(profil)
      },
      checkForm: function (e) {
        e.preventDefault();
        if (!this.emailRegex.test(this.email)) {
          this.error = true
        } else {
          this.error = false
          this.$store.commit('UPDATE_EMAIL', { email: this.email })
          this.$store.dispatch('sendData');
          this.$store.commit('SET_MODAL_TYPE', { type: 'merci' })
        }      
      },
      updateEmail: function(e) {
        this.email = e.target.value
      }
    }
}
</script>
